<template>
  <div class="guarantor-new">
    <div class="gua-form-step-container">
      <div class="form-scroller">
        <vue-scroll>
        <Tabs type="card" class="tab-square" v-if="data&&data.project" :animated="false" v-model="curTab">
          <div slot="extra">
            <Button @click="backward" type="primary" ghost size="small">上一步</Button>
            <Divider type="vertical" />
            <Button @click="preSubmit" type="success" size="small">提交</Button>
            <Divider type="vertical" />
            <Button @click="draft" type="info" size="small">存草稿</Button>
          </div>
          <TabPane label="确认并核对以下信息" name="basic">
            <div class="padding-top-20"></div>
            <Divider>保证金信息</Divider>
            <table class="brief-table">
              <tbody>
                <tr>
                  <td class="title">地区</td>
                  <td>{{getCityName(data.cityId)}}</td>
                  <td class="title">行业/领域</td>
                  <td>{{getIndustryName(data.industryId)}}</td>
                  <td class="title">种类</td>
                  <td>{{getGuaType(data.variety)}}</td>
                </tr>
                <tr>
                  <td class="title">受益单位</td>
                  <td colspan="3">{{data.beneficiary}}</td>
                  <td class="title">社会信用代码</td>
                  <td>{{data.beneficiaryBusinessLicense}}</td>
                </tr>
                <tr>
                  <td class="title">施工单位</td>
                  <td colspan="3">{{data.guaranteed}}</td>
                  <td class="title">社会信用代码</td>
                  <td>{{data.guaranteedBusinessLicense}}</td>
                </tr>
                <tr v-if="data.gMethod===0">
                  <td class="title">实缴金额</td>
                  <td>{{`¥ ${data.amount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元({{$common.transformNumberIntoCHS(data.amount/100)}})</td>
                  <td class="title">造价比</td>
                  <td>{{Math.round(data.amountCostRatio*10000)/100}}%</td>
                  <td class="title">缴纳日期</td>
                  <td>
                    {{require('moment')(data.gStartDate).format('YYYY-MM-DD')}}
                  </td>
                </tr>
                <tr>
                  <td class="title">经办机构</td>
                  <td>{{data.guarantorName}}</td>
                  <td class="title">经办人</td>
                  <td>{{data.opName}}</td>
                  <td class="title">联系电话</td>
                  <td>{{data.opContactTel}}</td>
                </tr>
              </tbody>
            </table>
            <div class="padding-top-20"></div>
            <div class="padding-top-20"></div>
            <Divider>项目信息</Divider>
            <table class="brief-table">
              <tbody>
                <tr>
                  <td class="title">项目名称</td>
                  <td>{{data.project.name}}</td>
                  <td class="title">项目类型</td>
                  <td>{{getPrjType(data.project.type).join('/')}}</td>
                  <td class="title">土地使用证编号</td>
                  <td>{{data.project.landLicenceNo||'-'}}</td>
                </tr>
                <tr>
                  <td class="title">项目立项备案号</td>
                  <td>{{data.project.filingNo}}</td>
                  <td class="title">规划许可证号</td>
                  <td>{{data.project.planLicenseNo}}</td>
                  <td class="title">施工许可证号</td>
                  <td>{{data.project.constrLicenceNo}}</td>
                </tr>
                <tr>
                  <td class="title">工程造价</td>
                  <td>{{`¥ ${data.project.cost}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元({{$common.transformNumberIntoCHS(data.project.cost)}})</td>
                  <td class="title">建设规模</td>
                  <td>{{data.project.area}}</td>
                  <td class="title">计划工期</td>
                  <td>
                    {{require('moment')(data.project.startdate).format('YYYY/MM/DD')}}
                    -
                    {{require('moment')(data.project.finishdate).format('YYYY/MM/DD')}}
                    ({{data.project.duration}}天)
                  </td>
                </tr>
                <tr>
                  <td class="title">质量要求</td>
                  <td colspan="5">{{data.project.qualityRequirement}}</td>
                </tr>
                <tr>
                  <td class="title">业主名称</td>
                  <td colspan="3">{{data.owner.name}}</td>
                  <td class="title">社会信用代码</td>
                  <td>{{data.owner.businessLicense}}</td>
                </tr>
                <tr>
                  <td class="title">总承包商名称</td>
                  <td colspan="3">{{data.contractor.name}}</td>
                  <td class="title">社会信用代码</td>
                  <td>{{data.contractor.businessLicense}}</td>
                </tr>
                <tr>
                  <td class="title">总承包合同备案号</td>
                  <td>{{data.contractorContractNo}}</td>
                  <td class="title">联系人</td>
                  <td>{{data.contractor.contact}}</td>
                  <td class="title">联系电话</td>
                  <td>{{data.contractor.contactTel}}</td>
                </tr>
                <tr>
                  <td class="title">监理企业名称</td>
                  <td colspan="3">{{data.supervisory?data.supervisory.name:''}}</td>
                  <td class="title">社会信用代码</td>
                  <td>{{data.supervisory?data.supervisory.businessLicense:''}}</td>
                </tr>
                <tr>
                  <td class="title">监理合同备案号</td>
                  <td>{{data.supervisoryContractNo}}</td>
                  <td class="title">联系人</td>
                  <td>{{data.supervisory?data.supervisory.contact:''}}</td>
                  <td class="title">联系电话</td>
                  <td>{{data.supervisory?data.supervisory.contactTel:''}}</td>
                </tr>
                <tr>
                  <td class="title">劳务分包负责人</td>
                  <td>{{data.distributorIncharge}}</td>
                  <td class="title">身份证号</td>
                  <td>{{data.distributorInchargeId}}</td>
                  <td class="title"></td>
                  <td></td>
                </tr>
                <tr>
                  <td class="title">劳务分包合同备案号</td>
                  <td>{{data.distributorContractNo}}</td>
                  <td class="title">联系人</td>
                  <td>{{data.distributorContact}}</td>
                  <td class="title">联系电话</td>
                  <td>{{data.distributorTel}}</td>
                </tr>
              </tbody>
            </table>
            <div class="padding-top-20"></div>
            <div class="padding-top-20"></div>
            <section v-if="data.contractOssKeys&&data.contractOssKeys instanceof Array&&data.contractOssKeys.length">
              <Divider>担保合同</Divider>
              <div class="contract">
                <!-- <div class="contract-thumb"
                  @click="previewImgUrl=img;showPreview=true"
                  :key="idx"
                  v-for="(img,idx) in data.contractOssKeys">
                  <img :src="img.url" v-if="img&&img.url&&img.type==='image'">
                  <span style="font-weight:bold;color:#999" v-if="img&&img.url&&img.type==='file'">{{img.surfix.toUpperCase()}}</span>
                </div> -->
                <div class="contract-thumb"
                  :key="idx"
                  v-for="(img,idx) in data.contractOssKeys">
                  <img :src="img.url" @click="handleImgPreview(data.contractOssKeys, idx)" v-if="img&&img.url&&img.type==='image'">
                  <span style="font-weight:bold;color:#999;padding:10px;cursor:pointer" v-if="img&&img.url&&img.type==='file'" @click="previewImgUrl=img;showPreview=true">{{img.surfix.toUpperCase()}}</span>
                </div>
              </div>
            </section>
            <section v-if="data.attachments&&data.attachments instanceof Array&&data.attachments.length">
              <div v-for="(att,idx) in data.attachments" :key="idx">
                <Divider>{{att.name}}</Divider>
                <div class="contract">
                  <!-- <div class="contract-thumb"
                    @click="previewImgUrl=img;showPreview=true"
                    :key="idx"
                    v-for="(img,idx) in att.urls">
                    <img :src="img.url" v-if="img&&img.url&&img.type==='image'">
                    <span style="font-weight:bold;color:#999" v-if="img&&img.url&&img.type==='file'">{{img.surfix.toUpperCase()}}</span>
                  </div> -->
                  <div class="contract-thumb"
                    :key="idx"
                    v-for="(img,idx) in att.urls">
                    <img :src="img.url" @click="handleImgPreview(att.urls, idx)" v-if="img&&img.url&&img.type==='image'">
                    <span style="font-weight:bold;color:#999;padding:10px;cursor:pointer" v-if="img&&img.url&&img.type==='file'" @click="previewImgUrl=img;showPreview=true">{{img.surfix.toUpperCase()}}</span>
                  </div>
                </div>
              </div>
            </section>
          </TabPane>
          <div class="padding-top-20"></div>
          <div class="padding-top-20"></div>
        </Tabs>
        </vue-scroll>
      </div>
      <div class="bottom-buttons">
        <Row :gutter="16">
          <Col span="4"><Button type="primary" ghost size="large" style="display:inline" long @click="backward">上一步</Button></Col>
          <Col span="16"><Button type="success" size="large" style="display:inline" long @click="preSubmit">提交</Button></Col>
          <Col span="4"><Button type="info" size="large" style="display:inline" long @click="draft">存草稿</Button></Col>
        </Row>
      </div>
    </div>
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null" width="1200">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <iframe :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'&&previewImgUrl.surfix==='pdf'" width="100%" height="800"></iframe>
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'&&previewImgUrl.surfix!='pdf'">查看</a>
    </Modal>
    <image-preview
      :minScale="1"
      :image-urls="imageUrls"
      :visible.sync="visiblePreviewer"
      :start-position="startPosition"></image-preview>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'guarantor-new',
  props: {
    data: Object
  },
  components: {
  },
  data () {
    return {
      loading: false,
      curTab: 'basic',
      cities: [],
      industries: [],
      prjTypes: [],
      guaTypes: [],
      showCertSelectModal: false,
      dataToSign: null,
      previewImgUrl: null,
      showPreview: false,
      visiblePreviewer: false,
      imageUrls: [],
      startPosition: 0
    }
  },
  watch: {
  },
  computed: {
  },
  mounted () {
    this.initCitySelect()
    this.initIndustrySelect()
    this.initPrjTypes()
    this.initGuaTypes()
    if (!this.data.cityId) {
      this.$router.push({path: '/receipts/new/step1'})
    }
    this.data.contractOssKeys = this.procOssKeys(this.data.contractOssKeys)
    if (this.data.attachments && this.data.attachments.length) {
      this.data.attachments.forEach((att) => {
        att.urls = this.procOssKeys(att.url)
      })
    }
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    backward () {
      this.$emit('go-backward')
    },
    getSysConfig (key) {
      return this.$store.getters.sysConfigs[key]
      // return configs(key)
    },
    procOssKeys (keys) {
      let result = []
      if (typeof(keys) === 'string') {
        if (keys.indexOf(',') === 0) {
          keys = keys.substr(1)
        }
        keys = keys.split(',')
      }
      keys.forEach(async (k, idx) => {
        try {
          result.push({})
          let url = await this.procOSSUrl(k)
          let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
          if (surfix.indexOf('?')) {
            surfix = surfix.substring(0, surfix.indexOf('?'))
          }
          let type = 'image'
          switch (surfix) {
            case 'jpg':
              type = 'image'
              break
            case 'jpeg':
              type = 'image'
              break
            case 'png':
              type = 'image'
              break
            case 'gif':
              type = 'image'
              break
            case 'pdf':
              type = 'file'
              break
            case 'doc':
              type = 'file'
              break
            case 'docx':
              type = 'file'
              break
            case 'xls':
              type = 'file'
              break
            case 'xlsx':
              type = 'file'
              break
            case 'ppt':
              type = 'file'
              break
            case 'pptx':
              type = 'file'
              break
            default:
              type = 'file'
              break
          }
          result[idx] = {
            name: k,
            url,
            type,
            surfix
          }
        } catch (e) {
          console.log(e)
        }
      })
      return result
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
    getCityName (cityId) {
      if (!this.cities.length) {
        this.initCitySelect().then((cities) => {
          this.data.cityName = cities.find(o => o.tid === parseInt(cityId)).name
          return this.data.cityName
        })
      } else {
        this.data.cityName = this.cities.find(o => o.tid === parseInt(cityId)).name
        return this.data.cityName
      }
    },
    initCitySelect () {
      return new Promise((resolve, reject) => {
        this.$Api.City.listCities({
          isVisible: null
        }, 1, 1000).then((cities) => {
          this.cities = cities.data
          resolve(cities.data)
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getIndustryName (industryId) {
      if (!this.industries.length) {
        this.initIndustrySelect().then((industries) => {
          this.data.industryName = industries.find(o => o.id === parseInt(industryId)).name
          return this.data.industryName
        })
      } else {
        this.data.industryName = this.industries.find(o => o.id === parseInt(industryId)).name
        return this.data.industryName
      }
    },
    initIndustrySelect () {
      return new Promise((resolve, reject) => {
        this.$Api.Industry.listIndustries({
        }, 1, 1000).then((res) => {
          this.industries = res.data
          resolve(res.data)
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getGuaType (type) {
      let guaType
      if (!this.guaTypes.length) {
        this.initPrjTypes().then((types) => {
          guaType = types.find(o => o.id === parseInt(type))
          return guaType ? guaType.fullName : null
        })
      } else {
        guaType = this.guaTypes.find(o => o.id === parseInt(type))
        return guaType.fullName
      }
    },
    async initGuaTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Guarantee.getGuaranteeVarieties().then(res => {
          this.guaTypes = res
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    getPrjType (type) {
      let prjType
      if (!this.prjTypes.length) {
        this.initPrjTypes().then((types) => {
          prjType = types.find(o => o.tid === parseInt(type))
        })
      } else {
        prjType = this.prjTypes.find(o => o.tid === parseInt(type))
      }
      if (prjType) {
        let prjTypeCur = [prjType.prjType]
        if (prjType.parentNode) {
          let parentNode = this.prjTypes.find(o => o.tid === prjType.parentNode)
          prjTypeCur.splice(0, 0, parentNode.prjType)
        }
        return prjTypeCur
      } else {
        return []
      }
    },
    async initPrjTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Project.getPrjTypes().then(res => {
          this.prjTypes = res
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    async draft () {
      this.$Spin.show()
      if (!this.data.guarantorId) {
        this.data.guarantorId = this.$store.getters.guarantorInfo.id
      }
      // if (this.data.jointGuarantors && this.data.jointGuarantors instanceof Array) {
      //   this.data.jointGuarantors.forEach((j) => {
      //     j.amount = j.amount * 100
      //   })
      // }
      // this.data.amount *= 100
      this.data.counterTotal = this.data.counterTotal * 100
      this.data.counterCash = this.data.counterCash * 100
      this.data.counter3rdparty = this.data.counter3rdparty * 100
      this.data.counterMortgage = this.data.counterMortgage * 100
      this.data.counterOther = this.data.counterOther * 100
      this.data.contractOssKeys = this.data.contractOssKeys.map((c) => {
        return c.name
      })
      if (this.data.attachments && this.data.attachments.length) {
        this.data.attachments.forEach((att) => {
          if (att.url instanceof Array) {
            att.url = att.url.join(',')
          }
        })
      }
      this.$Api.Receipt.draftReceipt(this.data).then(() => {
        this.$Message.success('操作成功')
        this.$Spin.hide()
      }).catch(err => {
        // if (this.data.jointGuarantors && this.data.jointGuarantors instanceof Array) {
        //   this.data.jointGuarantors.forEach((j) => {
        //     j.amount /= 100
        //   })
        // }
        // this.data.amount /= 100
        this.data.counterTotal = this.data.counterTotal / 100
        this.data.counterCash = this.data.counterCash / 100
        this.data.counter3rdparty = this.data.counter3rdparty / 100
        this.data.counterMortgage = this.data.counterMortgage / 100
        this.data.counterOther = this.data.counterOther / 100
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
    },
    async submit () {
      this.$Spin.show()
      this.$Api.Receipt.addReceipt(this.data).then(() => {
        this.$Message.success('操作成功')
        this.$Spin.hide()
      }).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
    },
    preSubmit () {
      this.data.contractOssKeys = this.data.contractOssKeys.map((c) => {
        return c.name
      })
      // if (this.data.jointGuarantors && this.data.jointGuarantors instanceof Array) {
      //   this.data.jointGuarantors.forEach((j) => {
      //     j.amount = j.amount * 100
      //   })
      // }
      // if (this.data.attachments && this.data.attachments.length) {
      //   this.data.attachments.forEach((att) => {
      //     att.url = att.url.join(',')
      //   })
      // }
      this.dataToSign = {
        id: this.data.id || null,
        attachments: this.data.attachments,
        orderNumber: this.data.orderNumber,
        guarantorName: this.data.guarantorName,
        prjId: this.data.prjId,
        cityId: this.data.cityId,
        cityName: this.data.cityName,
        industryId: this.data.industryId,
        industryName: this.data.industryName,
        ownerId: this.data.ownerId,
        contractorId: this.data.contractorId,
        contractorContractNo: this.data.contractorContractNo,
        contractorType: this.data.contractorType,
        constuctorId: this.data.constuctorId,
        supervisoryId: this.data.supervisoryId,
        supervisoryContractNo: this.data.supervisoryContractNo,
        supervisorId: this.data.supervisorId,
        distributorIncharge: this.data.distributorIncharge,
        distributorInchargeId: this.data.distributorInchargeId,
        distributorContact: this.data.distributorContact,
        distributorTel: this.data.distributorTel,
        distributorAddr: this.data.distributorAddr,
        distributorEmail: this.data.distributorEmail,
        distributorContractNo: this.data.distributorContractNo,
        beneficiary: this.data.beneficiary,
        beneficiaryBusinessLicense: this.data.beneficiaryBusinessLicense,
        beneficiaryAddress: this.data.beneficiaryAddress,
        guaranteed: this.data.guaranteed,
        guaranteedBusinessLicense: this.data.guaranteedBusinessLicense,
        guaranteedAddress: this.data.guaranteedAddress,
        fee: this.data.fee,
        amount: this.data.amount,
        amountCostRatio: this.data.amountCostRatio,
        variety: this.data.variety,
        counterRatio: this.data.counterRatio,
        counterTotal: this.data.counterTotal * 100,
        counterCash: this.data.counterCash * 100,
        counter3rdparty: this.data.counter3rdparty * 100,
        counterMortgage: this.data.counterMortgage * 100,
        counterOther: this.data.counterOther * 100,
        gMethod: this.data.gMethod,
        gStartDate: require('moment')(this.data.gStartDate).format('YYYY-MM-DD'),
        gFeeRate: this.data.gFeeRate,
        opName: this.data.opName,
        opContactTel: this.data.opContactTel,
        contractOssKeys: this.data.contractOssKeys
      }
      this.certSigned(this.dataToSign, false)
    },
    async certSigned (certSigned) {
      console.log(certSigned)
      this.$Spin.show()
      if (this.data.id) {
        let dataToSubmit = certSigned
        dataToSubmit = JSON.stringify(certSigned)
        await this.$Api.Receipt.updateReceipt(dataToSubmit).then(() => {
          // console.log(payload)
          this.$Message.success('提交成功!')
          this.loading = false
          this.$Spin.hide()
          this.$router.push('/receipts/list')
        })
        .catch(err => {
          this.loading = false
          this.$Spin.hide()
          this.$Notice.error({
            title: '提交失败!',
            desc: err.message
          })
        })
      } else {
        await this.$Api.Receipt.addReceipt(certSigned).then(() => {
          // console.log(payload)
          this.$Message.success('提交成功!')
          this.loading = false
          this.$Spin.hide()
          this.$router.push('/receipts/list')
        })
        .catch(err => {
          this.loading = false
          this.$Spin.hide()
          this.$Notice.error({
            title: '提交失败!',
            desc: err.message
          })
        })
      }
    },
    handleImgPreview (list, index) {
      this.imageUrls = list.map((l) => {return l.url})
      this.visiblePreviewer = true
      this.startPosition = index
    }
  }
}
</script>

<style lang="less" scoped>
.guarantor-new {
  position: relative;
  height: 100%;
}
.gua-form-step-container {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
  .form-scroller {
    flex: 1;
    overflow: auto;
  }
  .bottom-buttons {

  }
}
.contract {
  display: flex;
  flex-direction: row;
}
.contract-thumb {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-color: #efefef;
  width: 100px;
  height: 100px;
  margin-right: 8px;
  transition: all .2s ease-in-out;
  padding: 3px;
  border: 1px solid #d2d2d2;
  &:hover {
    border: 1px solid rgb(65,157,253);
    background-color: #fff;
  }
  overflow: hidden;
  img {
    cursor: pointer;
    width: 100%;
  }
}
</style>
